import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const GlassCard = ({ children, className = '', style = {}, onClick }) => {
  const { theme } = useTheme();
  const glassStyle = {
    background: theme.glass.background,
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    borderRadius: '16px',
    border: theme.glass.border,
    boxShadow: theme.glass.shadow,
    padding: '24px',
    transition: 'all 0.3s ease',
    ...style,
  };

  if (onClick) {
    glassStyle.cursor = 'pointer';
    glassStyle[':hover'] = {
      transform: 'translateY(-2px)',
      boxShadow: `0 12px 40px 0 ${theme.glass.shadow}`,
    };
  }

  return (
    <div
      className={className}
      style={glassStyle}
      onClick={onClick}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = `0 12px 40px 0 ${theme.glass.shadow}`;
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = theme.glass.shadow;
        }
      }}
    >
      {children}
    </div>
  );
};

export default GlassCard;






